<template>

  <div class="modal fade" id="entryDeleteModal" tabindex="-1" aria-labelledby="entryDeleteModalLabel" aria-hidden="true" ref="modalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="entryDeleteModalLabel">Megerősítés szükséges</h5>
        </div>
        <div class="modal-body">
          <p>
            <span class="fw-bold">Biztos, törlöd a foglalást?</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" @click="agree" class="btn btn-danger" data-bs-dismiss="modal">Igen</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Mégse</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { Modal } from 'bootstrap'
import Account from "@/views/User/Account.vue";

export default {
  name: 'ProgramDateDeleteAgree',
  props: ['initData'],
  data(){
    return{
      modalInstance : null,

    }
  },
  methods:{
    agree(){
      this.closeModal()

      Account.methods.programDelete(this.$parent,this.initData.modals.programDeleteAgree,true)
    },
    openModal(){
      this.modalInstance = new Modal(document.getElementById('entryDeleteModal'))
      this.modalInstance.show()
    },
    closeModal(){
      this.modalInstance = new Modal(document.getElementById('entryDeleteModal'))
      this.modalInstance.hide();
    }
  }
}
</script>
<style>

</style>